module.exports = __webpack_public_path__ + "img/hotline-W.e94d7a12.jpg";